/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { useCallback } from "react";
import { useNavigate } from "react-router";

export const SIGN_OUT_PATH = "/sign-out";

/** Signing out is a move like any other, so a page with unsaved work gets to ask first. */
export function useSignOut(): () => void {
  const navigate = useNavigate();
  return useCallback(() => void navigate(SIGN_OUT_PATH), [navigate]);
}
